<script setup>
import {computed, ref, watch, nextTick} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useItemDataStore} from '@/stores/itemData'
import {useViewStore} from '@/stores/view'

import UserTrackingAvatar from '@/common/UserTrackingAvatar'
import ListViewRowTitle from './ListViewRowTitle'
import TableViewEditBtn from './TableViewEditBtn'

const props = defineProps({
    viewId: String,
    id: Number,
})

const viewStore = useViewStore(props.viewId)

const router = useRouter()
const route = useRoute()

const itemDataStore = useItemDataStore()

const show = ref(true)
const item = ref(undefined)

const tableName = computed(() => viewStore.tableName)
const selectMode = computed(() => viewStore.selectMode)

watch(
    () => [tableName.value, props.id],
    async ([newTable, newId]) => {
        if (!newTable || !newId) {
            item.value = undefined
            return
        }

        item.value = await itemDataStore.get({
            tableName: newTable,
            id: newId
        })
    },
    {immediate: true}
)

watch(item, () => {
    show.value = false
    nextTick(() => {
        show.value = true
    })
})

const onClick = () => {
    viewStore.onClick(props.id)
}

const onDblClick = () => {
    const hasAccess = viewStore.onDblClick()
    if (hasAccess) {
        router.push({
            name: 'form',
            params: {id: props.id},
            query: route.query
        })
    }
}

const onShiftClick = () => {
    viewStore.onShiftClick(props.id)
}

const onMetaClick = () => {
    viewStore.onMetaClick(props.id)
}
</script>

<template>
    <div v-if="item && show" class="d-flex align-items-center" @dblclick="onDblClick" @click.left.exact="onClick"
         @click.shift="onShiftClick" @click.meta="onMetaClick">
        <div class="flex-fill">
            <UserTrackingAvatar :item-id="id" :table-name="tableName"/>
            <ListViewRowTitle :id="id" :view-id="viewId"/>
        </div>

        <span class="text-nowrap">
            <TableViewEditBtn :id="id" :select-mode="selectMode" :view-id="viewId"/>
        </span>
    </div>
</template>